import {Alert, Form} from "react-bootstrap";
import PropTypes from "prop-types";
import {LabelFor} from "./LabelFor.jsx";

export const Checkbox = (props) => {
    return (
        <Form.Group className={props.className}>
            <div className={'d-flex flex-row-reverse align-items-center justify-content-center'}>
                <LabelFor label={props.label} hideLabel={props.hideLabel} tooltipText={props.tooltipText}/>

                <Form.Check
                    id={props.id || props.name + props?.idx || props.ariaLabel + props?.idx || props.label + props?.idx}
                    aria-label={props.label || props.title || 'wybierz'}
                    title={props.title}
                    disabled={props.disabled}
                    readOnly={props.readOnly}
                    data-testid="check"
                    type="checkbox"
                    className="me-2"
                    onChange={props.onChange}
                    checked={props.value === true || props.value === "Tak" || props.value === 1}
                />
            </div>

            {props.errorText && (
                <Alert className={"p-1 w-100"} variant={"danger"}>
                    <div className={"ms-1"}> {props.errorText}</div>
                </Alert>
            )}
        </Form.Group>
    );
};

Checkbox.defaultProps = {
    label: "",
};

Checkbox.propTypes = {
    onChange: PropTypes.func.isRequired,
    value: PropTypes.PropTypes.oneOfType([PropTypes.bool, PropTypes.number, PropTypes.string]),
    label: PropTypes.string,
    className: PropTypes.string,
    disabled: PropTypes.bool,
    title: PropTypes.string,
    readOnly: PropTypes.bool,
    id: PropTypes.string,
    hideLabel: PropTypes.bool,
    ariaLabel: PropTypes.string,
    errorText: PropTypes.string,
    idx: PropTypes.number,
    name: PropTypes.string,
    tooltipText: PropTypes.string,

};

